import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-401',
  templateUrl: './page-401.component.html',
  styleUrls: ['./page-401.component.css']
})
export class Page401Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  
}
